import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/archive";

const navItems = [
  { to: "/", label: "首页", icon: "ri-home-5-line" },
  { to: "/archives", label: "人物档案", icon: "ri-user-search-line" },
  { to: "/about", label: "关于本站", icon: "ri-questionnaire-line" },
];

export default function Header() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50">
      {/* 顶部彩条 */}
      <div className="h-1 bg-gradient-to-r from-primary-500 via-accent-500 to-secondary-500" />
      <div
        className={`border-b border-background-200 transition-all duration-300 ${
          scrolled ? "bg-background-50/95 backdrop-blur" : "bg-background-50"
        }`}
      >
        <div className="container-x flex items-center justify-between gap-4 py-3.5">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-bold text-foreground-950">新瓜档案</span>
              <span className="mt-0.5 text-[11px] tracking-widest text-foreground-500">新晋人物吃瓜档案</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {navItems.map((it) => (
              <Link
                key={it.to}
                to={it.to}
                className={`flex items-center gap-1.5 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  location.pathname === it.to
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                <i className={it.icon} />
                {it.label}
              </Link>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <Link
              to="/archives"
              className="btn border border-background-300 bg-background-100 px-4 py-2 text-foreground-700 hover:bg-background-200"
            >
              <i className="ri-search-line" />
              <span className="text-foreground-500">搜新面孔</span>
            </Link>
            <Link to="/archives" className="btn bg-primary-500 px-4 py-2 text-background-50 hover:bg-primary-600">
              看新瓜 <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md bg-background-100 text-foreground-800 md:hidden"
          >
            <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>

        {/* 桌面端栏目条 */}
        <div className="container-x hidden border-t border-background-200 py-2.5 lg:block">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-1 text-xs">
            <span className="font-semibold text-primary-600">热门栏目</span>
            {categories.map((c) => (
              <Link key={c.slug} to={`/archives?cat=${c.slug}`} className="whitespace-nowrap text-foreground-500 transition-colors hover:text-primary-600">
                {c.name}
              </Link>
            ))}
            <span className="ml-auto flex items-center gap-1.5 text-foreground-500">
              <i className="ri-time-line" /> 每日 12:00 / 18:00 更新
            </span>
          </div>
        </div>

        {/* 移动端菜单 */}
        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-2 md:hidden">
            <nav className="flex flex-col gap-1">
              {navItems.map((it) => (
                <Link
                  key={it.to}
                  to={it.to}
                  className={`flex items-center gap-2.5 rounded-md px-3 py-2.5 text-sm font-medium ${
                    location.pathname === it.to ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  <i className={it.icon} /> {it.label}
                </Link>
              ))}
            </nav>
            <div className="mt-3 flex flex-wrap gap-2 border-t border-background-200 pt-3">
              {categories.map((c) => (
                <Link
                  key={c.slug}
                  to={`/archives?cat=${c.slug}`}
                  className="rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-600"
                >
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}